"use client";
import { config } from "@/lib/config";
import { DrupalNode } from "next-drupal";
import Image from "next/image";
import React from "react";
import { motion } from "framer-motion";

interface FlagCardProps {
  data: DrupalNode;
}

const FlagCard = ({ data }: FlagCardProps) => {
  const isBlue = data?.field_background_color === "blue";
  const isWhite = data?.field_background_color === "white";
  const isGray = data?.field_background_color === "gray";
  const isDarkDray = data?.field_background_color === "dark_gray";

  const bgClass = isBlue
    ? "bg-[#003350]"
    : isWhite
      ? "bg-white"
      : isGray
        ? "bg-[#f9f9f9]"
        : isDarkDray
          ? "bg-mapGray"
          : "bg-white";

  return (
    <div className={`${bgClass} overflow-hidden w-full`} id="our-supporters">
      <div className="mini-container h-full flex flex-col items-center justify-center relative z-[3] pt-[120px] pb-[56px] mobileMax:pt-12 mobileMax:pb-8">
        {data?.field_title && (
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: 0,
            }}
            className={`remove-animation-fluctuation font-semibold bg-[linear-gradient(to_top,#8EBCE5,#11375C)] bg-clip-text text-transparent leading-tight ${
              data?.field_title_position === "left" ? "text-left" : "text-center"
            } capitalize text-[48px] mobileMax:text-[28px] mb-14 betweenMobileTab:mb-8 mobileMax:mb-6`}
          >
            {data?.field_title}
          </motion.h2>
        )}

        <div className="grid grid-cols-2 tab:grid-cols-3 exactLaptop:grid-cols-4 laptop:grid-cols-4 desktop:grid-cols-4 items-center justify-center gap-6 desktopLg:gap-8 mobileMax:gap-x-4 mobileMax:gap-y-6 w-full">
          {data?.field_add_card?.map(
            (supporterCards: DrupalNode, index: number) => {
              return (
                <motion.div
                  key={index}
                  className="flex flex-col items-center justify-center w-full"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 0,
                  }}
                >
                  <div className="flex flex-col items-center justify-start w-full">
                    <div className="w-[270px] h-[175px] desktopLg:w-[290px] desktopLg:h-[185px] tab:w-[210px] tab:h-[135px] mobileMax:w-[135px] mobileMax:h-[85px] relative rounded-[14px] overflow-hidden flex items-center justify-center shadow-xl transition-transform duration-300 hover:scale-105">
                      <Image
                        src={`${config.apiBase}${
                          supporterCards?.field_image?.uri?.url || ""
                        }`}
                        alt={supporterCards?.field_title || "supporter img"}
                        fill
                        className="object-cover object-center w-full h-full"
                      />
                    </div>

                    {supporterCards?.field_title && (
                      <h3 className="text-center font-semibold text-[22px] desktopLg:text-[24px] tab:text-[18px] mobileMax:text-[14px] mt-[14px] mobileMax:mt-[8px] text-white leading-snug">
                        {supporterCards?.field_title}
                      </h3>
                    )}
                  </div>
                </motion.div>
              );
            },
          )}
        </div>
      </div>
    </div>
  );
};

export default FlagCard;
